import { render, staticRenderFns } from "./DeleteSharedDrive.vue?vue&type=template&id=bb644b82"
import script from "./DeleteSharedDrive.vue?vue&type=script&lang=js"
export * from "./DeleteSharedDrive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports